import React from 'react';
import Card from "olive-react-myoneui/lib/Card";
import { reminderModuleName } from '../../constants/config';
import { useTranslation } from 'react-i18next';

function NoItemsInfoReminder({
  className
}) {
  const { t } = useTranslation(reminderModuleName);
  return (
    <Card className={`${className || ""} empty-block-card`}>
      <Card.Body className="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
        <div className="empty-block">
          <h6><strong>{t('No_Reminders')}</strong></h6>
          <p>{t('No_reminders_message')}</p>
        </div>
      </Card.Body>
    </Card>
  );
}

export default React.memo(NoItemsInfoReminder);
